<h1>Reports</h1>
<div>
	<mat-accordion [multi]="true" [togglePosition]="'before'">
		<mat-expansion-panel class="mat-elevation-z0 expansion-panel" [expanded]="false">
			<mat-expansion-panel-header>
				<mat-panel-title>
					<h4>WFDSS Incidents After 03/26/2025</h4>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<wfdss-case-search-report></wfdss-case-search-report>
		</mat-expansion-panel>
		<mat-expansion-panel class="mat-elevation-z0 expansion-panel" [expanded]="false">
			<mat-expansion-panel-header>
				<mat-panel-title>
					<h4>WFDSS Incident Data Prior to 03/26/2025</h4>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<wfdss-legacy-incident-search></wfdss-legacy-incident-search>
		</mat-expansion-panel>
	</mat-accordion>
</div>
